import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { getDas28History } from "../connections/getApi";
import { setError, setLoading } from "../redux/slices/prescriptionSlice";
const UseFetchDas28History = (patientId) => {
    const dispatch = useDispatch();
    return useQuery({
        queryKey: ["getDas28History", patientId],
        queryFn: () => getDas28History(patientId),
        enabled: !!patientId,
        onError: () => {
            dispatch(setError(true));
            dispatch(setLoading(false));
        },
        onSettled: () => {
            dispatch(setLoading(false));
        },
    });
};

export default UseFetchDas28History;
